import { z } from '../zod';
import { ObjectIdStringValidationSchema } from '../shared/ObjectId';
import {
  TicketTypeInputValidationSchema,
  withFreeTicketTypePriceCheck,
} from '../event-page/create';
import {
  TICKET_TYPE_IMAGE_ID_DESCRIPTION,
  TICKET_TYPE_TRIGGER_ID_DESCRIPTION,
  TicketGroupPathParamsValidationSchema,
  TicketTypeEventIdInputSchema,
} from './params';
import { TicketTypeShowHideLogicInputValidationSchema } from './showHideLogic';

export const CreateTicketTypeParamsValidationSchema = TicketGroupPathParamsValidationSchema;

export const CreateTicketTypeRequestValidationSchema = withFreeTicketTypePriceCheck(
  TicketTypeInputValidationSchema.omit({
    key: true,
    triggerTicketTypeId: true,
    showHideLogic: true,
  }).extend({
    triggerTicketTypeId: ObjectIdStringValidationSchema.nullish(),
    showHideLogic: TicketTypeShowHideLogicInputValidationSchema.nullish(),
  }),
).openapi('CreateTicketTypeRequest');

export const CreateTicketTypeInputValidationSchema = withFreeTicketTypePriceCheck(
  z.object({
    pageId: TicketTypeEventIdInputSchema,
    ticketGroupId: ObjectIdStringValidationSchema.meta({
      description:
        "The ID of the ticket group to add the ticket type to. get_event lists the event's groups under `ticketGroups[].id`.",
    }),
    ...CreateTicketTypeRequestValidationSchema.shape,
    imageId: ObjectIdStringValidationSchema.nullish().meta({
      description: TICKET_TYPE_IMAGE_ID_DESCRIPTION,
    }),
    triggerTicketTypeId: ObjectIdStringValidationSchema.nullish().meta({
      description: TICKET_TYPE_TRIGGER_ID_DESCRIPTION,
    }),
  }),
);

export type CreateTicketTypeInput = z.infer<typeof CreateTicketTypeInputValidationSchema>;
